// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operationCard_wrapper__Z10Zm {
  width: 100%;
  min-width: 240px;
  width: fit-content;
  height: 92px;
  padding: 5px;
  padding-right: 10px;
  border: 1px solid var(--Gray88);
  border-radius: 10px;
  background: var(--WhiteSmoke);
  cursor: pointer; }
  .operationCard_wrapper__Z10Zm:hover .operationCard_titleBlock__BYNF6 .operationCard_title__BvpgK {
    color: var(--Orange); }
  .operationCard_wrapper_opasity__GbZMp {
    opacity: 0.6; }

.operationCard_block__n7dE0 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px; }
  .operationCard_block_title__jDvJ6 {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--HightEmphasis);
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    max-width: 200px;
    white-space: nowrap; }

.operationCard_footer__Sm1JH {
  display: flex;
  justify-content: space-between;
  align-items: center; }
  .operationCard_footer_text__-WMaz {
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    color: var(--MediumEmphasis);
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    max-width: 200px;
    white-space: nowrap; }
`, "",{"version":3,"sources":["webpack://./src/pages/previewOrders/components/OperationCard/operationCard.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAUA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe,EAAA;EAVjB;IAYI,oBAAoB,EAAA;EAEtB;IACE,YAAY,EAAA;;AAIhB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB,EAAA;EACnB;ICSA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDTf,2BAA2B;IAjC7B,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB,EAAA;;AAkCrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAA;EACnB;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IA9C9B,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB,EAAA","sourcesContent":["@import 'src/styles/fonts';\n\n@mixin dots {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  max-width: 200px;\n  white-space: nowrap;\n}\n\n.wrapper {\n  width: 100%;\n  min-width: 240px;\n  width: fit-content;\n  height: 92px;\n  padding: 5px;\n  padding-right: 10px;\n  border: 1px solid var(--Gray88);\n  border-radius: 10px;\n  background: var(--WhiteSmoke);\n  cursor: pointer;\n  &:hover .titleBlock .title {\n    color: var(--Orange);\n  }\n  &_opasity {\n    opacity: 0.6;\n  }\n}\n\n.block {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  &_title {\n    @include body2;\n    color: var(--HightEmphasis);\n    @include dots;\n  }\n}\n\n.footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  &_text {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 24px;\n    color: var(--MediumEmphasis);\n    @include dots;\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `operationCard_wrapper__Z10Zm`,
	"titleBlock": `operationCard_titleBlock__BYNF6`,
	"title": `operationCard_title__BvpgK`,
	"wrapper_opasity": `operationCard_wrapper_opasity__GbZMp`,
	"block": `operationCard_block__n7dE0`,
	"block_title": `operationCard_block_title__jDvJ6`,
	"footer": `operationCard_footer__Sm1JH`,
	"footer_text": `operationCard_footer_text__-WMaz`
};
export default ___CSS_LOADER_EXPORT___;
